import { render } from "./VerifyOrder.vue?vue&type=template&id=51c2506e&scoped=true"
import script from "./VerifyOrder.vue?vue&type=script&lang=js"
export * from "./VerifyOrder.vue?vue&type=script&lang=js"

import "./VerifyOrder.vue?vue&type=style&index=0&id=51c2506e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c2506e"]])

export default __exports__